import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, CircleDashed, FileText } from './Icons';
import './ProjectCard.css';

export default function ProjectCard({ project, onSelect }) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (onSelect) onSelect(project);
    else navigate(`/app/project/${project.id}`);
  };

  const getStatusBadge = () => {
    return <span className="badge badge-primary"><Activity size={12} style={{ marginRight: 4 }} /> Active</span>;
  };

  const hasScope = project.scopeKnowledge?.deliverables?.length > 0;

  return (
    <div className="project-card card" onClick={handleCardClick} role="button" tabIndex={0}>
      <div className="project-card-header">
        <div className="project-avatar">
          {(project.projectName || '?').slice(0, 2).toUpperCase()}
        </div>
        <div className="project-meta">
          <h3 className="project-title">{project.projectName}</h3>
          {project.clientName && <span className="project-client">{project.clientName}</span>}
        </div>
      </div>

      <div className="project-card-stats">
        <div className="stat">
          <span className="stat-label">Evaluations:</span>
          <span className="stat-value">{project.evaluationCount || 0}</span>
        </div>
      </div>

      <div className="project-card-footer">
        {getStatusBadge()}
        {hasScope ? (
          <span className="scope-indicator verified"><FileText size={12} style={{ marginRight: 4 }}/> Scope loaded</span>
        ) : (
          <span className="scope-indicator pending"><CircleDashed size={12} style={{ marginRight: 4 }} /> No scope PDF</span>
        )}
      </div>
    </div>
  );
}
